/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.throttle = function (fn, timeWindow, tail) {
    if (timeWindow === void 0) { timeWindow = 500; }
    if (tail === void 0) { tail = false; }
    var lastExecution = new Date(new Date().getTime() - timeWindow);
    var tailTimeout;
    var throttledFN = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (tailTimeout) {
            clearTimeout(tailTimeout);
        }
        if (lastExecution.getTime() + timeWindow <= new Date().getTime()) {
            lastExecution = new Date();
            return fn.apply(void 0, args);
        }
        else if (tail) {
            tailTimeout = window.setTimeout(throttledFN, timeWindow);
        }
    };
    return throttledFN;
};